import type {
  GetAllPostsByAppVariantAndSelectedGeoAreasRequest,
  PagedModelClientPost
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevinePostApi } from '@/features/api/hooks/grapevine-post/useGrapevinePostApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { flattenPostsToGenericPostDetails } from '@/features/posts/utils/flattenPostsToGenericPostDetails';

export const useGetLimitedPostsBySelectedGeoAreas = (
  requestParameters: GetAllPostsByAppVariantAndSelectedGeoAreasRequest
) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevinePostApi();

  return useQuery({
    // Todo: why is the conversion needed here?
    queryKey: [
      API_CACHE_KEYS.POST_FEED_LIMITED,
      { ...requestParameters, types: [...(requestParameters.types ?? [])] }
    ],
    queryFn: () =>
      api.getAllPostsByAppVariantAndSelectedGeoAreas(requestParameters),
    enabled: isAuthenticated,
    select: useCallback(
      (data: PagedModelClientPost) =>
        flattenPostsToGenericPostDetails(data.content),
      []
    )
  });
};
